import React, { useState } from 'react';
import Box from 'reusecore/src/elements/Box';
import { useQuery } from '@apollo/client';
import { GET_RELATED_REVIEWS } from '@core/ui/graphql/Profile.query';
import ListGrid from 'reusecore/src/elements/ListGrid';
import Review from '../../components/Review';
import TextLoader from '../../components/Loader/TextLoader';
import { Col, Row } from 'react-styled-flexboxgrid';
import Rate from '../../components/Rate';
import useMediaQuery from '../../helpers/mediaQuery';

const UserReviews = props => {
  const { uid } = props;

  const [loadingMore, toggleLoading] = useState(false);

  const isMobile = useMediaQuery('(max-width: 600px)');
  const isTablet = useMediaQuery('(max-width: 1023px)');

  const QUERY_VARIABLES = {
    USERNAME: uid,
  };

  const { data, loading, error, fetchMore, refetch, networkStatus } = useQuery(
    GET_RELATED_REVIEWS,
    {
      variables: QUERY_VARIABLES,
      ssr: false,
    }
  );

  const handleRefetch = () => {
    refetch();
  };

  let {
    author: {
      rating: { data: rating = [] } = {},
      reviews: { data: reviews = [], total = 0 } = {},
    } = {},
  } = data || {};

  if (reviews === null) {
    reviews = [];
  }

  const reviewsCount = reviews.length;

  const renderRelatedReviews = item => {
    const {
      id = '',
      createdAt = '',
      creatorAlternateName = '',
      creatorCertified = '',
      global = '',
      title = '',
      message = '',
    } = item;

    return (
      <>
        <Review
          id={id}
          title={title}
          message={message}
          rate={global}
          creatorAlternateName={creatorAlternateName}
          creatorCertified={creatorCertified}
          createdAt={createdAt}
        />
      </>
    );
  };

  const renderGlobalRating = rating => {
    if (rating.length < 1) {
      rating = [{}];
    }

    const {
      global = 0,
      communication = 0,
      punctuality = 0,
      quality = 0,
    } = rating[0];

    return (
      <Rate
        global={global}
        communication={communication}
        punctuality={punctuality}
        quality={quality}
        uid={uid}
        handleAddReview={handleRefetch}
      />
    );
  };

  return (
    <>
      <h3>Avis ({reviewsCount})</h3>
      <Box mt={30} width={1}>
        <Row>
          {reviewsCount > 0 && (
            <Col
              md={8}
              xs={12}
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                order: isMobile || isTablet ? 1 : 0,
              }}
            >
              <ListGrid
                data={reviews}
                reviewsCount={reviewsCount}
                columnWidth={1}
                component={renderRelatedReviews}
                loading={loading ? loading : loadingMore}
                placeholder={<TextLoader />}
              />
            </Col>
          )}
          <Col
            md={4}
            xs={12}
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              marginBottom: 15,
              order: isMobile || isTablet ? 0 : 1,
            }}
          >
            {renderGlobalRating(rating)}
          </Col>
        </Row>
      </Box>
    </>
  );
};

export default UserReviews;
